/**
 * @generated SignedSource<<d4d20b8197deec218dca1e71010f03b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MerchantStoreState = "INACTIVE" | "LIVE" | "RETIRED" | "UNKNOWN" | "%future added value";
export type useMerchantStoresRelayByIdQuery$variables = {
  id: string;
};
export type useMerchantStoresRelayByIdQuery$data = {
  readonly getMerchantStore: {
    readonly banner: {
      readonly id: string;
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly lat: number | null | undefined;
    readonly lng: number | null | undefined;
    readonly logo: {
      readonly id: string;
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly oldId: string | null | undefined;
    readonly organizationId: string;
    readonly primaryColor: string | null | undefined;
    readonly secondaryColor: string | null | undefined;
    readonly state: MerchantStoreState | null | undefined;
    readonly websiteUrl: string | null | undefined;
  } | null | undefined;
};
export type useMerchantStoresRelayByIdQuery = {
  response: useMerchantStoresRelayByIdQuery$data;
  variables: useMerchantStoresRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MerchantStore",
    "kind": "LinkedField",
    "name": "getMerchantStore",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "websiteUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lat",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lng",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secondaryColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "logo",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "banner",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMerchantStoresRelayByIdQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMerchantStoresRelayByIdQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "fc214723a737f774519fa2c47ebb789c",
    "id": null,
    "metadata": {},
    "name": "useMerchantStoresRelayByIdQuery",
    "operationKind": "query",
    "text": "query useMerchantStoresRelayByIdQuery(\n  $id: ID!\n) {\n  getMerchantStore(id: $id) {\n    id\n    oldId\n    name\n    websiteUrl\n    lat\n    lng\n    primaryColor\n    secondaryColor\n    organizationId\n    state\n    logo {\n      id\n      url\n    }\n    banner {\n      id\n      url\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c581bfee4b295f09f3331000fc3ad67e";

export default node;
